<template>
	<header-block title="Featured"></header-block>
	<CustomerLoadWait :customer="customer" />

	<div class="header-panel">
		<v-row class="content-row">
			<v-col class="v-col-8">
				<h1 class="title">Featured</h1>
			</v-col>
			<v-col class="v-col-4 voucher-count">
				<span v-if="featuredVouchers">{{ featuredVouchers.length }} Vouchers</span>
			</v-col>
		</v-row>
	</div>

	<div class="mt-6" v-if="featuredVouchers">
		<VoucherList
			:showAll="true" 
			:vouchers="featuredVouchers" 
			:search="false" 
			:showSaving="false" 
			:showFavourites="true"
			@favouriteToggled="(v) => { favouriteToggled(v); }"
			:formatter="formatter" />
	</div>
	<div class="mt-6" v-else>
		<div v-for="i in 4" :key="i" class="mb-2">
			<v-skeleton-loader
				type="list-item-avatar-two-line"
			></v-skeleton-loader>
		</div>
	</div>

	<p v-if="!loading && featuredVouchers.length==0" class="centered">
		No vouchers available at this time.
	</p>

	<div style="clear:both; "></div>
	
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import VoucherList from './elements/VoucherList.vue';

export default {
	mixins: [Services],
	components: {CustomerLoadWait, HeaderBlock, VoucherList},
	data() {
		return {
			loading: true,
			featuredVouchers: null,
		}
	},
	methods: {
		onLoad: async function() {
			this._getCustomer();
			this.loadAvailable();
		},
		loadAvailable: function(){
			this._getAvailableVouchers(() => {
				this.featuredVouchers = this.availableVouchers.filter(v => v.featured);
				this.loading = false;
			});
		},
		favouriteToggled: function(voucher) {
			if (voucher.favourite) {
				this._removeCustomerFavouriteDiscount(voucher, () => {
					voucher.favourite = !voucher.favourite;
				});
			} else {
				this._addCustomerFavouriteDiscount(voucher, () => {
					voucher.favourite = !voucher.favourite;
				});
			}
		},
		topSavings(vouchers) {
			var top = vouchers.sort((a, b) => {
				return (b.savingsAmount || 0) - (a.savingsAmount || 0);
			});
			return top.slice(0, 5);
		},
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>
.header-panel {
	background-color: #281c3b;
	color: white;
	padding: 20px 30px;
	margin: -20px -30px;
	height: 108px;
	position: relative;
	overflow: hidden;
}

.content-row {
	position: relative;
	z-index: 1;
}

.header-panel h1 {
	font-size: 28px;
	font-weight: bold;
}

.voucher-count {
	text-align: right;
	align-self: center;
	font-size: 13px;
	margin-top: 30px;
}

.topTabButton
{
	margin-top: 0px;
	text-transform: none;
	padding-top: 17px !important;
	padding-bottom: 30px !important;
	vertical-align: middle !important;
	background-color: #ffffff66 !important;
	font-weight: bold;
}

.topTabButton.selected {
    background-color: var(--text-color) !important;
	color: white !important;
}

.topMenuCol {
	padding-left: 3px;
	padding-right: 3px;
}

.topMenuRow
{
	margin-left: -5px;
	margin-right: -5px;
	margin-bottom: 15px;
}

h1.title {
	font-size: 28px;
	margin-top: 30px
}

</style>
